import { render, staticRenderFns } from "./SolicitarDespachos.vue?vue&type=template&id=5bae6a3b&scoped=true&"
import script from "./SolicitarDespachos.vue?vue&type=script&lang=js&"
export * from "./SolicitarDespachos.vue?vue&type=script&lang=js&"
import style0 from "./SolicitarDespachos.vue?vue&type=style&index=0&id=5bae6a3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae6a3b",
  null
  
)

export default component.exports